import React, { Component } from "react";
import ReactDOM from "react-dom";
import {
  Map,
  Marker,
  InfoWindow,
  GoogleApiWrapper,
  Polyline,
} from "google-maps-react";
import createHistory from "history/createBrowserHistory";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import "./styles/style.scss";

if (!window.AppHistory) {
  window.AppHistory = createHistory();
}

class InfoWindowEx extends Component {
  constructor(props) {
    super(props);
    this.infoWindowRef = React.createRef();
    this.contentElement = document.createElement("div");
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.children !== prevProps.children) {
      ReactDOM.render(
        React.Children.only(this.props.children),
        this.contentElement
      );
      this.infoWindowRef.current.infowindow.setContent(this.contentElement);
    }
  };

  render() {
    return <InfoWindow ref={this.infoWindowRef} {...this.props} />;
  }
}

export class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Size: props.heidIcon ? props.heidIcon : 45,
      activeMarker: {},
      dataRecieve: props.dataDrawer,
      tags: "",
      dataOptions: props.dataOptions ? props.dataOptions : {},
      markerInfo: {},
      polylineDefault: "",
      polyline: props.polyline ? props.polyline : [],
      marker: props.marker,
      type: props.type,
      showingInfoWindow: false,
      showDrawerInfo: false,
    };
    this.buttonRef = React.createRef();
  }

  componentDidMount = () => {
    this.setState(
      {
        marker: this.props.marker,
      },
      () => {
        this.buildTags();
      }
    );
  };

  componentWillReceiveProps = (nextProps) => {
    this.setState(
      {
        marker: nextProps.marker,
        showDrawerInfo: nextProps.showDrawerInfo
      },
      () => {
        this.setState({ polyline: nextProps.polyline }, () => this.buildTags());
      }
    );
    this.setState(
      {
        dataRecieve: nextProps.dataDrawer,
        dataOptions: nextProps.dataOptions,
      },
      () => {
        let sendData = {
          data: nextProps.dataDrawer,
        };
        this.onMarkerClick(sendData, null, null);
      }
    );
  };

  onMarkerClick = (props, marker, e) => {
    switch (this.state.type) {
      case "info":
        this.setState({ showingInfoWindow: false }, () => {
          this.setState({
            showingInfoWindow: true,
            activeMarker: props.data,
            markerInfo: marker,
          });
        });
        break;
      case "drawer":
        this.setState({ showDrawerInfo: false }, () => {
          this.setState({ showDrawerInfo: true, activeMarker: props.data });
        });
        break;
      case "polyline":
        if (props.data) {
          if (props.data.POLLatitude && props.data.PODLatitude) {
            let polyline = [
              {
                lat: parseFloat(props.data.POLLatitude),
                lng: parseFloat(props.data.POLLongitude),
              },
              {
                lat: parseFloat(props.data.PODLatitude),
                lng: parseFloat(props.data.PODLongitude),
              },
            ];
            this.setState({ polyline: polyline });
          }
        }
        break;
      case "polylineDrawer":
        if (props.data) {
          if (props.data.POLLatitude && props.data.PODLatitude) {
            let polyline = [
              {
                lat: parseFloat(props.data.POLLatitude),
                lng: parseFloat(props.data.POLLongitude),
              },
              {
                lat: parseFloat(props.data.PODLatitude),
                lng: parseFloat(props.data.PODLongitude),
              },
            ];
            this.setState({ polyline: polyline });
          }
          this.setState({ showDrawerInfo: false }, () => {
            this.setState({ showDrawerInfo: true, activeMarker: props.data });
          });
        }
        break;
      default:
    }
  };

  onInfoWindowClose = () => {
    this.setState({
      showingInfoWindow: false,
    });
  };

  buildTags = () => {
    let { marker, type } = this.state;
    let tags = [];
    let polylineDefault = [];

    let sizeIconW = 0
    let sizeIconH = 0

    marker.map((e) => {

      if (e.icon.url === 'https://magiclog.blob.core.windows.net/europartnerspic/tracking-mapaTCC.png') {
        sizeIconW = 13
        sizeIconH = 25
      }
      else {
        sizeIconW = 25
        sizeIconH = 25
      }

      tags.push(
        <Marker
          key={e.key}
          onClick={this.onMarkerClick}
          title={e.title}
          name={e.name}
          info={e}
          data={e.data}
          position={e.position}
          icon={{
            url: e.icon.url,
            scaledSize: new window.google.maps.Size(sizeIconW, sizeIconH),
          }}
        />
      );
      return e;
    });
    var lineSymbol = {
      path: "M 0,-1 0,1",
      strokeOpacity: 1,
      scale: 3,
    };
    if (type === "polyline") {
      polylineDefault.push(
        <Polyline
          key={Math.random()}
          path={this.props.data ? this.props.data : []}
          icons={[
            {
              icon: lineSymbol,
              offset: "0",
              repeat: "20px",
            },
          ]}
          strokeOpacity={0}
        />
      );
    }
    if (type === "polylineDrawer") {
      polylineDefault.push(
        <Polyline
          key={Math.random()}
          path={this.props.data ? this.props.data : []}
          icons={[
            {
              icon: lineSymbol,
              offset: "0",
              repeat: "20px",
            },
          ]}
          strokeOpacity={0}
        />
      );
    }
    this.setState({ tags, polylineDefault });
  };

  render() {
    let {
      markerInfo,
      polyline,
      polylineDefault,
    } = this.state;

    if (!this.props.google) {
      return <div>Loading...</div>;
    }

    var dataOptions = this.state.dataOptions ? this.state.dataOptions.data : "";

    if (dataOptions && markerInfo) {
      dataOptions.map((e) => {
        if (markerInfo.info) {
          e.value = markerInfo.info[e.key];
        }
        return e;
      });
    }

    return (

      <Map
        styles={[
          {
            elementType: "geometry",
            stylers: [{ color: "#fdfbfb" }],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "red" }],
          },
          {
            elementType: "labels.text.fill",
            stylers: [{ color: "red" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#42AFEE" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#515c6d" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#42AFEE" }],
          },
        ]}
        disableDefaultUI={true}
        google={this.props.google}
        zoom={this.props.zoom ? this.props.zoom : 2}
        initialCenter={
          this.props.position
            ? this.props.position
            : {
              lat: 14.3005846,
              lng: -46.447409,
            }
        }
      >
        {this.state.tags}
        {polylineDefault}
        <Polyline
          path={polyline}
          options={{
            strokeColor: "#000a2e",
            // strokeOpacity: 0.8,
            strokeWeight: 3,
            icons: [
              {
                icon: {
                  path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                },
                offset: "0%",
                repeat: "50px"
              },
            ],
          }}
        />
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyAl_10ZKSqnrviAV-KSQ6c8i4Sa_gEhEmA",
  v: "3.30",
})(withNamespaces()(withRouter(MapContainer)));
